import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import "../Admin/Admin.css";
import { useNavigate } from "react-router-dom";
import AdminView from "../../Assets/img/Eye.svg";
import AdminEdit from "../../Assets/img/Edit.svg";
import AdminDelete from "../../Assets/img/Delete.svg";
import Loading from "../../Loading/loading";
import human from "../../Assets/img/Icon.png";
import { useLocation } from "react-router-dom";
import Search from "../../Assets/img/search.png";
const Contactusform = () => {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [languageId, setLanguageId] = useState(1);
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    // ✅ Fetch Admin List
    const fetchAdmins = () => {
        setLoading(true);
        API.post("Contactusform_list/condition", {
            language_id: languageId,
            search,
            rowsPerPage,
            page,
        })
            .then((response) => {
                const resData = response.data?.data || {};
                const list = resData.data || [];
                const totalCount = resData.totalCount || 0;

                setAdmins(list.filter((a) => a.active !== 4));
                setTotalPages(Math.ceil(totalCount / rowsPerPage));
            })
            .catch((err) => console.error("Error fetching admins:", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchAdmins();
    }, [page, languageId]);

    // ✅ Open Delete Popup
    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };
    const handleNext = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) setPage(page - 1);
    };
    const handleSearch = () => {
        localStorage.removeItem("candidatePage");
        setPage(1);
        fetchAdmins();
    };
    useEffect(() => {
        if (location.state?.page) {
            setPage(location.state.page);

            // clear state AFTER restoring
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);


    return (
        <div className="admin-container">
            <div className="news-header">
                <h2 className="news-title">ContactUs Form List</h2>
            </div>

            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search candidates..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            value={languageId}
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                                setPage(1);
                            }}

                            className="input-field"
                        >

                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div className="filter-btn-wrapper" onClick={handleSearch}>
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>


            {/* Admin Table */}
            <div className="admin-table-wrapper">
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>s.no</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email</th>
                                    <th>Message</th>
                                    <th>Services</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            {admins.length > 0 ? (
                                <tbody>
                                    {admins.map((admin) => (
                                        <tr key={admin.form_id}>
                                            <td>{admins.indexOf(admin) + 1}</td>
                                            <td>{admin.first_name}</td>
                                            <td>{admin.last_name}</td>
                                            <td>{admin.email}</td>
                                            <td>{admin.message}</td>
                                            <td>{admin.label}</td>
                                            <td>
                                                <span className={`badge status-badge ${admin.active === 1 ? "text-bg-success" : "text-bg-danger"}`} style={{ fontSize: "14px" }}>
                                                    {admin.active === 1 ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="action-buttons">
                                                    {/* Hide Edit/Delete for Super Admin */}
                                                    {admin.form_id && (
                                                        <>
                                                            <img
                                                                src={AdminView}
                                                                alt="View"
                                                                className="admin-icon-btn"
                                                                onClick={() =>
                                                                    navigate(`/contactusformview/${admin.form_id}`, {
                                                                        state: { adminData: admin, page },
                                                                    })
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                            No Contact Us found.
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                        {/* Pagination */}
                        {totalPages > 1 && (
                            <div className="pagination-container">
                                <button
                                    className="pagination-btn"
                                    onClick={handlePrev}
                                    disabled={page === 1}
                                >
                                    Prev
                                </button>

                                {/* Page Numbers */}
                                {(() => {
                                    const pageNumbers = [];
                                    const maxVisible = 5;

                                    if (totalPages <= maxVisible) {
                                        for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);

                                    } else {
                                        if (page <= 3) {
                                            pageNumbers.push(1, 2, 3, 4, "...", totalPages);

                                        } else if (page >= totalPages - 2) {
                                            pageNumbers.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);

                                        } else {
                                            pageNumbers.push(
                                                1,
                                                "...",
                                                page - 1,
                                                page,
                                                page + 1,
                                                "...",
                                                totalPages
                                            );
                                        }
                                    }

                                    return pageNumbers.map((num, index) =>
                                        num === "..." ? (
                                            <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                                                ...
                                            </span>
                                        ) : (
                                            <button
                                                key={num}
                                                className={`pagination-btn ${page === num ? "active" : ""}`}
                                                onClick={() => setPage(num)}
                                            >
                                                {num}
                                            </button>
                                        )
                                    );
                                })()}
                                <button
                                    className="pagination-btn"
                                    onClick={handleNext}
                                    disabled={page === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* 🧩 Delete Confirmation Popup */}

        </div>
    );
};

export default Contactusform;
